import { render, staticRenderFns } from "./WorkPositionAccordion.vue?vue&type=template&id=0a4603f5&scoped=true&"
import script from "./WorkPositionAccordion.vue?vue&type=script&lang=js&"
export * from "./WorkPositionAccordion.vue?vue&type=script&lang=js&"
import style0 from "./WorkPositionAccordion.vue?vue&type=style&index=0&id=0a4603f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4603f5",
  null
  
)

export default component.exports